
import {
  DxAsyncRule,
  DxColumn,
  DxDataGrid,
  DxEditing,
  DxEmailRule,
  DxFormat,
  DxItem,
  DxLookup,
  DxPaging,
  DxPatternRule,
  DxRequiredRule,
  DxScrolling,
  DxToolbar,
} from "devextreme-vue/data-grid";
import { DxSelectBox } from "devextreme-vue/select-box";
import { LoadOptions } from "devextreme/data/index";
import { Component, Vue } from "vue-property-decorator";
import IndexationController from "../../shared/services/controllers/indexation/indexationController";

import { apiUrls } from "@/environment/environment";
import { DxButton } from "devextreme-vue/button";

import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { ContentReadyEvent } from "devextreme/ui/select_box";

import { EditorPreparingEvent, OptionChangedEvent } from "devextreme/ui/data_grid";
import notify from "devextreme/ui/notify";
import { IndexFamily, ParamsOptions, Tarif, TarifGeneral } from "../../shared/types/Indexation";

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxLookup,
    DxToolbar,
    DxItem,
    DxButton,
    DxSelectBox,
    DxFormat,
    DxRequiredRule,
    DxEmailRule,
    DxPatternRule,
    DxAsyncRule,
    DxScrolling,
  },
})
export default class TarifsGrille extends Vue {
  private controller: IndexationController;

  constructor() {
    super();
    this.controller = new IndexationController(apiUrls.indexation);
  }

  selectedIndexFamily: IndexFamily | null = null;
  getSelectedIndexFamily(): IndexFamily | null {
    return this.selectedIndexFamily;
  }

  selectedDisabled = false;
  handlePropertyChange(e: OptionChangedEvent): void {
    if (e.name === "editing") {
      this.selectedDisabled = (this.$refs.dxDataGrid as DxDataGrid)?.instance?.hasEditData() ?? false;
    }
  }

  storeTarif = new CustomStore({
    key: "id",
    load: async (loadOptions: LoadOptions) => {
      let selectedIndexFamily = this.getSelectedIndexFamily();
      if (selectedIndexFamily) {
        return await this.controller.indexationStore.getListeTarifs(selectedIndexFamily).then((result) => {
          return {
            data: result.data,
            totalCount: result.itemsCount,
          };
        });
      }
    },
    insert: async (values) => {
      let selectedIndexFamily = this.getSelectedIndexFamily();
      if (selectedIndexFamily) {
        await this.controller.indexationStore
          .addTarif(values, selectedIndexFamily)
          .then((result) => {
            notify(
              {
                message: "message success",
                width: 400,
                type: "success",
                displayTime: 3500,
                animation: {
                  show: {
                    type: "fade",
                    duration: 400,
                    from: 0,
                    to: 1,
                  },
                  hide: { type: "fade", duration: 40, to: 0 },
                },
              },
              { position: "top right", direction: "down-push" }
            );
          })
          .catch((error) => {
            notify(
              {
                message: error,
                width: 400,
                type: "error",
                displayTime: 3500,
                animation: {
                  show: {
                    type: "fade",
                    duration: 400,
                    from: 0,
                    to: 1,
                  },
                  hide: { type: "fade", duration: 40, to: 0 },
                },
              },
              { position: "top right", direction: "down-push" }
            );
          });
      }
    },
    update: async (key, values) => {
      let tarif: Tarif | undefined = undefined;

      // recuperation des data de la grille pour les fusionner avec les modifications
      const gridInstance = (this.$refs.dxDataGrid as DxDataGrid)?.instance;
      if (gridInstance) {
        const rowIndex: number = gridInstance.getRowIndexByKey(key);
        if (rowIndex > -1) {
          tarif = gridInstance.getVisibleRows()[rowIndex].data;
        }
      }
      // fusion des données avec les modifications
      tarif = { ...tarif, ...values };

      if (tarif) {
        await this.controller.indexationStore
          .updateTarif(key, tarif)
          .then((result) => {
            notify(
              {
                message: "message success",
                width: 400,
                type: "success",
                displayTime: 3500,
                animation: {
                  show: {
                    type: "fade",
                    duration: 400,
                    from: 0,
                    to: 1,
                  },
                  hide: { type: "fade", duration: 40, to: 0 },
                },
              },
              { position: "top right", direction: "down-push" }
            );
          })
          .catch((err) => {
            notify(
              {
                message: err,
                width: 400,
                type: "error",
                displayTime: 3500,
                animation: {
                  show: {
                    type: "fade",
                    duration: 400,
                    from: 0,
                    to: 1,
                  },
                  hide: { type: "fade", duration: 40, to: 0 },
                },
              },
              { position: "top right", direction: "down-push" }
            );
          });
      }
    },
    remove: async (key) => {
      await this.controller.indexationStore
        .removeTarif(key)
        .then((result) => {
          notify(
            {
              message: "message success",
              width: 400,
              type: "success",
              displayTime: 3500,
              animation: {
                show: {
                  type: "fade",
                  duration: 400,
                  from: 0,
                  to: 1,
                },
                hide: { type: "fade", duration: 40, to: 0 },
              },
            },
            { position: "top right", direction: "down-push" }
          );
        })
        .catch((err) => {
          notify(
            {
              message: err,
              width: 400,
              type: "error",
              displayTime: 3500,
              animation: {
                show: {
                  type: "fade",
                  duration: 400,
                  from: 0,
                  to: 1,
                },
                hide: { type: "fade", duration: 40, to: 0 },
              },
            },
            { position: "top right", direction: "down-push" }
          );
        });
    },
  });

  storeIndexFamily = new CustomStore({
    key: "id",
    load: async (loadOptions: LoadOptions) => {
      return await this.controller.indexationStore.getListeIndexFamily().then((result) => {
        return {
          data: result.data,
          totalCount: result.itemsCount,
        };
      });
    },
  });

  dataSourceTarif = new DataSource({
    store: this.storeTarif,
  });

  dataSourceIndexFamily = new DataSource({
    store: this.storeIndexFamily,
  });

  dataSourceTarifGeneral = {
    store: new CustomStore({
      key: "id",
      load: async (loadOptions: LoadOptions) => {
        let selectedIndexFamily = this.getSelectedIndexFamily();
        const requestOptions: ParamsOptions = { searchValue: loadOptions.searchValue, offset: loadOptions.skip, limit: loadOptions.take };
        if (selectedIndexFamily) {
          return await this.controller.indexationStore
            .getListeTarifGeneral(selectedIndexFamily, requestOptions)
            .then((result) => {
              return {
                data: result.data,
                totalCount: result.itemsCount,
              };
            })
            .catch(() => {
              throw new Error("Network error");
            });
        }
      },
      byKey: async (key: number) => {
        return await this.controller.indexationStore.getTarifGeneral(key);
      },
    }),
    paginate: true,
    pageSize: 20,
  };

  selectIndexFamilyChanged() {
    let dxDataGrid = this.$refs.dxDataGrid as DxDataGrid;
    dxDataGrid?.instance?.refresh();
  }

  initialized = false;
  onContentReady(e: ContentReadyEvent) {
    if (!this.initialized) {
      this.initialized = true;
      e.component
        .getDataSource()
        .load()
        .then((res: IndexFamily[]) => {
          e.component.option("value", res[0]);
        });
    }
  }

  onEditorPreparing(e: EditorPreparingEvent): void {
    // Enable la date en edition
    if (e.dataField == "tarifGeneral" && e.parentType == "dataRow") {
      e.editorOptions.disabled = !e.row?.isNewRow;
    }
  }

  getTarifGeneralCodeName(e: TarifGeneral) {
    return `${e.code} - ${e.libelle}`;
  }

  sortingTarifCustom(rowData: any) {
    return `${rowData.tarifGeneral.code} - ${rowData.tarifGeneral.libelle}`;
  }

  asyncTarifValidation(params: any) {
    let selectedIndexFamily = this.getSelectedIndexFamily();
    return this.controller.indexationStore.validateNewTarif(params.data.tarifGeneral, selectedIndexFamily);
  }

  beforeMount() {
    this.initialized = false;
  }
}
